import React from 'react';
import Header from '../Header&Footer/Header';
import HiringHero from './Hero';
import LogoCloud from './LogoCloud';
import Industries from './Industries';
import HiringFeatures from './Features';
import ProductTour from './ProductTour';
import HowItWorks from './HowItWorks';
import AIHumanHybrid from './AIHumanHybrid';
import Comparison from './Comparison';
import CheatingDetection from './CheatingDetection';
import Security from './Security';
import HiringTestimonials from './Testimonials';
import PricingTeaser from './PricingTeaser';
import FAQ from './FAQ';
import FinalCTA from './FinalCTA';
import Footer from '../Header&Footer/Footer';
import ScrollReveal from './ScrollReveal';
import useSEO from './useSEO';

/**
 * SearchJob.ai marketing landing page — full assembly.
 *
 * Section order, with the storytelling intent of each block:
 *
 *   1. Hero            — Live agent run (spotlight + flow trail)
 *   2. LogoCloud       — "who else uses this" social proof (marquee)
 *   3. Industries      — "we serve your vertical"
 *   4. Features        — End-to-end platform capabilities
 *   5. ProductTour     — Auto-rotating product screens (#product-tour)
 *   6. HowItWorks      — The 4-step workflow from requisition to hire
 *   7. AIHumanHybrid   — Reframes the AI fear: AI does volume work,
 *                        humans make the decisions
 *   8. Comparison      — "here is how we beat the alternatives"
 *   9. CheatingDetection — Integrity spotlight: real evidence signals
 *  10. Security        — Dark trust band: shipped controls + honest
 *                        compliance roadmap (no unverified badges)
 *  11. Testimonials    — Customer voice (featured + stacked layout)
 *  12. PricingTeaser   — "here is what it costs"
 *  13. FAQ             — Remaining buyer concerns (+ FAQPage JSON-LD)
 *  14. FinalCTA        — Book the demo / start the trial (dark panel)
 *  15. Footer          — Navigation + newsletter
 *
 * Files preserved on disk but NOT imported (re-enable when relevant):
 *   • ProblemSolution.jsx — negative-framing problem-first section
 *   • Integrations.jsx    — ATS / HRMS connectors not built yet
 *
 * Every below-the-fold section is wrapped in <ScrollReveal> so each
 * fades + slides into view as the user scrolls.
 */
export default function HiringPage() {
  // ─── SEO meta tags ──────────────────────────────────────────────
  useSEO({
    title:
      'SearchJob.ai — End-to-End AI Recruitment Platform | Sourcing to Offer',
    description:
      'SearchJob.ai is the complete AI hiring platform. Write JDs, screen resumes, interview candidates with realtime AI video, run coding and behavioral tests, detect cheating, and host video interviews — all in one place. Trusted by 500+ hiring teams across India.',
    keywords:
      'AI recruitment platform, AI resume screening, AI video interview, coding test platform, cheating detection, job description creator, public career page, personality test, behavioral test, video interview platform, recruitment software India, end-to-end hiring',
    canonical: 'https://searchjob.ai/',
    ogImage: 'https://searchjob.ai/og-image.png',
    type: 'website',
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* pt-16 offsets the fixed-position header (h-16 = 64px). */}
      <main className="pt-16">
        <HiringHero />

        
        <ScrollReveal>
          <LogoCloud />
        </ScrollReveal>

        <ScrollReveal>
          <HiringFeatures />
        </ScrollReveal>

        

        {/* <ScrollReveal>
          <ProductTour />
          </ScrollReveal> */}

        <ScrollReveal>
          <HowItWorks />
        </ScrollReveal>

        

        {/* <ScrollReveal>
          <AIHumanHybrid />
          </ScrollReveal> */}

        {/* <ScrollReveal>
          <Comparison />
          </ScrollReveal> */}

        {/* <ScrollReveal>
          <CheatingDetection />
          </ScrollReveal> */}

        {/* <ScrollReveal>
          <Security />
          </ScrollReveal> */}

        

        <ScrollReveal>
          <HiringTestimonials />
        </ScrollReveal>

        {/* <ScrollReveal>
          <PricingTeaser />
          </ScrollReveal> */}

        <ScrollReveal>
          <FAQ />
        </ScrollReveal>

        <ScrollReveal>
            <Industries />
          </ScrollReveal>
          

        <ScrollReveal>
          <FinalCTA />
        </ScrollReveal>
      </main>
          

      <Footer />
    </div>
  );
}
